// src/components/SharePuzzle.js
import React from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  PinterestShareButton,
  PinterestIcon,
  EmailShareButton,
  EmailIcon,
  TwitterShareButton,
  TwitterIcon
} from 'react-share';

const SharePuzzle = ({ puzzleUrl, title = "Check out this puzzle!" }) => {
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(puzzleUrl);
      alert('Link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
      <h3>Share this Puzzle</h3>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
        <FacebookShareButton url={puzzleUrl} quote={title}>
          <FacebookIcon size={40} round />
        </FacebookShareButton>
        <WhatsappShareButton url={puzzleUrl} title={title}>
          <WhatsappIcon size={40} round />
        </WhatsappShareButton>
        <PinterestShareButton url={puzzleUrl} media={puzzleUrl}>
          <PinterestIcon size={40} round />
        </PinterestShareButton>
        <TwitterShareButton url={puzzleUrl} title={title}>
          <TwitterIcon size={40} round />
        </TwitterShareButton>
        <EmailShareButton url={puzzleUrl} subject={title}>
          <EmailIcon size={40} round />
        </EmailShareButton>
        <button onClick={copyToClipboard} style={{ padding: '0.5rem', fontSize: '1rem' }}>
          📋 Copy Link
        </button>
      </div>
    </div>
  );
};

export default SharePuzzle;
